import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { IKeenIconsProps } from './types';

// KeenIcon using forwardRef to pass the ref and spread props
export const KeenIcon = forwardRef<HTMLElement, IKeenIconsProps>(
    ({ icon, style, className = '', ...props }, ref) => {
        // Spread props and apply the ref to the <i> element
        return (
            <i
                ref={ref}
                {...props}
                className={clsx(`ki-${style ?? 'filled '}`, `ki-${icon}`, className)}
            />
        );
    }
);

// Set the displayName for the component
KeenIcon.displayName = 'KeenIcon';

export default KeenIcon;
